import {
    POST_SCHEDULE_BOOKING_REQUEST,
    POST_SCHEDULE_BOOKING_SUCCESS,
    POST_SCHEDULE_BOOKING_FAIL,
    CHECK_AVAILABILITY_REQUEST,
    CHECK_AVAILABILITY_SUCCESS,
    CHECK_AVAILABILITY_FAIL,
    FIND_NEAREST_DRIVER_REQUEST,
    FIND_NEAREST_DRIVER_SUCCESS,
    FIND_NEAREST_DRIVER_FAIL,
    RESET_SCHEDULE_BOOKING_FORM,
} from '../constants/ScheduleBookingConstants'

const postInit  = { savedBooking: null, loading: false, error: null, success: false }
const checkInit = { isAvailable: null,  loading: false, error: null }
const nearestInit = { nearest: null, toArea: null, ranked: [], loading: false, error: null }

export const postScheduleBookingReducer = (state = postInit, action) => {
    switch (action.type) {
        case POST_SCHEDULE_BOOKING_REQUEST: return { ...state, loading: true,  error: null, success: false }
        case POST_SCHEDULE_BOOKING_SUCCESS: return { ...state, loading: false, savedBooking: action.payload, success: true, error: null }
        case POST_SCHEDULE_BOOKING_FAIL:    return { ...state, loading: false, error: action.payload, success: false }
        case RESET_SCHEDULE_BOOKING_FORM:   return postInit
        default: return state
    }
}

export const checkAvailabilityReducer = (state = checkInit, action) => {
    switch (action.type) {
        case CHECK_AVAILABILITY_REQUEST: return { ...state, loading: true,  error: null, isAvailable: null }
        case CHECK_AVAILABILITY_SUCCESS: return { ...state, loading: false, isAvailable: action.payload, error: null }
        case CHECK_AVAILABILITY_FAIL:    return { ...state, loading: false, error: action.payload, isAvailable: false }
        default: return state
    }
}

export const findNearestDriverReducer = (state = nearestInit, action) => {
    switch (action.type) {
        case FIND_NEAREST_DRIVER_REQUEST: return { ...state, loading: true,  error: null, nearest: null }
        case FIND_NEAREST_DRIVER_SUCCESS: return { ...state, loading: false, nearest: action.payload.nearest, toArea: action.payload.toArea, ranked: action.payload.ranked, error: null }
        case FIND_NEAREST_DRIVER_FAIL:    return { ...state, loading: false, error: action.payload }
        default: return state
    }
}